<script>
import DocumentValidationDataTable
  from '@/components/document-validation/documentValidationDataTable/DocumentValidationDataTable.vue'
export default {
  components: { DocumentValidationDataTable },
  props: {
    selectedOrder: Object,
    isVisible: Boolean,
  },
  data() {
    return {
      updatedEvent: null
    }
  },
  methods: {
    closeOrderDialog() {
      this.$emit('close')
    }
  },
}
</script>
<template>
  <v-dialog
    v-if="selectedOrder !== null"
    v-model="isVisible"
    @click:outside="closeOrderDialog">
    <v-card>
      <DialogBaseColoredTitle>
          <span>
            {{ $t('component.orders.ordersDocumentsDialog.table.order') + ' ' + selectedOrder.orderNumber }}
          </span>
      </DialogBaseColoredTitle>
      <DialogBaseCloseIcon color="white" @click="closeOrderDialog"/>
      <v-divider></v-divider>
      <DialogBaseText>
        <DocumentValidationDataTable
          :key="selectedOrder.orderId"
          :order="selectedOrder"
          :can-delete="$ordersService.canDeleteOrder(selectedOrder)"
          @update:updated="updatedEvent = $event" />
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseActions>
        <v-btn color="primary" @click="closeOrderDialog">
            <span>{{ $t('button.close') }}</span>
        </v-btn>
      </DialogBaseActions>
    </v-card>
  </v-dialog>
</template>